"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useFindMenuGroup = groupTitle => {
  const [menuItems, setMenuItems] = (0, _react.useState)([]);
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const {
    menuGroups
  } = pageData;
  (0, _react.useEffect)(() => {
    var _menuGroups$find;
    const items = menuGroups === null || menuGroups === void 0 || (_menuGroups$find = menuGroups.find(group => group.title === groupTitle)) === null || _menuGroups$find === void 0 ? void 0 : _menuGroups$find.items;
    setMenuItems(items);
  }, [groupTitle, menuGroups]);
  return menuItems;
};
var _default = exports.default = useFindMenuGroup;